<app-keycom-container
  *ngIf="user"
  [logo]="'assets/images/ovt-logo.svg'"
  [title]="title"
  [user]="user"
  (helpAction)="helpAction($event)"
  (profileAction)="profileAction($event)"
>
  <!-- Top Bar -->
  <keycom-top-bar>
    <app-bread-crumbs></app-bread-crumbs>
  </keycom-top-bar>

  <!-- App System Bar -->
  <app-system-top-bar
    [structure]="structure"
    [keySystem]="keySystem"
    [keySystemDataSets]="keySystemDataSets"
    [keywayFamily]="keywayFamily"
    [combinatingRule]="combinatingRule"
  >
  </app-system-top-bar>

  <!-- App -->
  <router-outlet></router-outlet>
</app-keycom-container>
